import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import TextareaField from 'Pods/Shared/TextareaField'

function SendMessageForm({
  handleFileUpload = null,
  handleSubmit,
  handleMessageInput,
  message,
  isDisabledSubmit,
  isSuspendedMessaging,
  showAttachments = false,
  attachments = null,
  isRestricted = true,
  rows,
}) {
  const formClassName = !isRestricted ? 'non-restricted-form' : ''

  return (
    <form className={`messaging-input ${formClassName}`}>
      <textarea
        id="messageInputText"
        onChange={handleMessageInput}
        placeholder="Type or drag & drop files here…"
        name="new_message"
        value={message}
        rows={rows}
      />
      {attachments.length > 0 && (
        <div className="message__attachments row">
          {attachments}
        </div>
      )}
      <div className="send-message-form__actions">
        {showAttachments && (
          <label className="btn attach-file-button">
            <Icon type={['far', 'paperclip']} />
            <input type="file" multiple className="attach-file" onChange={(e) => handleFileUpload(e)} disabled={isSuspendedMessaging} />
          </label>
        )}
        <button
          type="submit"
          className={`btn btn-primary submit-form-button ${isDisabledSubmit || isSuspendedMessaging ? 'is-disabled' : null}`}
          onClick={(e) => handleSubmit(e)}
          disabled={isDisabledSubmit || isSuspendedMessaging}
        >
          Send
        </button>
      </div>
    </form>
  )
}

SendMessageForm.propTypes = {
  props: PropTypes.shape({
    handleFileUpload: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    handleMessageInput: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    isDisabledSubmit: PropTypes.bool.isRequired,
    isSuspendedMessaging: PropTypes.bool.isRequired,
    showAttachments: PropTypes.bool,
    attachments: PropTypes.array,
    isRestricted: PropTypes.bool,
    rows: PropTypes.number.isRequired,
  }),
}

export default SendMessageForm
